import gql from 'graphql-tag'

export const getMenuNotificationsGql = gql`
  query NotificacoesMenu {
    notificacoesMenu {
      id
      titulo
      texto
      produto
      link
      data
      recente
    }
  }
`

export const GetMenuCountNotificationsQueryName = 'GetMenuCountNotifications'

export const getMenuCountNotificationsGql = gql`
  query GetMenuCountNotifications {
    countNotificacoesNaoLidas
  }
`
